import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { SiteConfig } from './types';

export function useSite() {
  return useQuery({ queryKey: ['site'], queryFn: () => api.get<SiteConfig>('/api/public/site').then((r) => r.data), staleTime: 5 * 60_000 });
}
